import { Stack, router } from "expo-router";
import { HeaderBackButton } from "expo-router/build/react-navigation";
import { useTranslation } from "react-i18next";

import { useStackHeader } from "@/components/navigation/useStackHeader";
import { TEST_IDS } from "@/testIdDefinition";

// Theme, language and other children reload with this index underneath,
// so the header back button returns to /settings.
export const unstable_settings = {
    anchor: "index",
};

export default function SettingsLayout() {
    const stackHeaderProps = useStackHeader();
    const { t } = useTranslation();

    return (
        <Stack
            screenOptions={{
                ...stackHeaderProps,
                headerShown: true,
            }}
        >
            <Stack.Screen
                name="index"
                options={{
                    title: t("nav.settings"),
                    // First screen of this stack, so the nested navigator cannot
                    // go back. The parent stack still can (tabs, or the screen
                    // settings was opened from).
                    headerLeft: ({ tintColor }) => (
                        <HeaderBackButton
                            tintColor={tintColor}
                            label=""
                            onPress={() => router.back()}
                            testID={TEST_IDS[TEST_IDS.STACK_BACK_BUTTON]}
                        />
                    ),
                }}
            />
        </Stack>
    );
}
